<template>
  <div>
    <layout-header></layout-header>
    <menu-pc></menu-pc>
    <menu-mobile></menu-mobile>
    <router-view class="main-content"></router-view>
    <layout-footer></layout-footer>
    <layout-copyright></layout-copyright>
    <!-- <right-side></right-side> -->
  </div>
</template>

<script>
import LayoutHeader from './LayoutHeader'
import MenuPc from './MenuPC'
import MenuMobile from './MenuMobile'
import LayoutFooter from './LayoutFooter'
import LayoutCopyright from './LayoutCopyright'
import RightSide from './RightSide'
export default {
  name: 'Layout',
  data() {
    return {
    };
  },
  components: {
    LayoutHeader,
    MenuPc,
    MenuMobile,
    LayoutFooter,
    LayoutCopyright,
    RightSide
  }
};
</script>

<style lang="" scoped>
.main-content{
  margin: 0 auto;
  margin-top: 120px;
  overflow: hidden;
}

@media screen and (max-width: 920px){
  .main-content{
    margin-top: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Layout/Layout.vue